module.exports = __webpack_public_path__ + "img/reverso.2b826be7.svg";